import { render, staticRenderFns } from "./groupTab.vue?vue&type=template&id=6f239584&scoped=true"
import script from "./groupTab.vue?vue&type=script&lang=js"
export * from "./groupTab.vue?vue&type=script&lang=js"
import style0 from "./groupTab.vue?vue&type=style&index=0&id=6f239584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f239584",
  null
  
)

export default component.exports